const mutations = {
  datos (state: any, payload: any) {
    state.datos = payload.datos
  }
}

export default mutations
